import { render, staticRenderFns } from "./RouterModal.vue?vue&type=template&id=3121f226&"
import script from "./RouterModal.vue?vue&type=script&lang=js&"
export * from "./RouterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports